/**
 * Email capture popup (sections/email-popup.liquid).
 * Opens after a delay or on exit intent, once per visitor, and stays closed for
 * `data-remember-days` after it is dismissed or submitted. Never opens on cart/checkout.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var KEY = 'jax:email-popup';

  function readState() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function remember(days) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + days * 86400000 }));
    } catch (e) {
      /* private mode — the popup simply shows again next visit */
    }
  }

  function suppressed() {
    var state = readState();
    return !!(state && state.until && state.until > Date.now());
  }

  function init(root) {
    if (!root || root.__emailPopup) return;
    root.__emailPopup = true;

    var days = parseInt(root.getAttribute('data-remember-days'), 10);
    if (isNaN(days)) days = 30;
    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 15;

    var form = root.querySelector('form');
    var posted = !!root.querySelector('.newsletter-form__message--success');
    var path = window.location.pathname || '';
    /*
      A 5%-off retail discount has no business interrupting someone mid-way through a bulk quote,
      and the form on that page takes longer to fill in than the popup's delay. Keying off the
      #quote anchor means any future quote page inherits this. The contact_posted clause stops the
      modal opening over a "thanks, we'll be in touch" message on every contact form site-wide.

      Product pages are on that list for a harder reason. The popup is z-index 100 and fixed to the
      bottom of the viewport; the sticky buy bar was 4. So fifteen seconds into every mobile product
      visit the popup opened straight over the only Add to cart a phone buyer ever sees — the real
      one is ~2,085px down the page. Mobile took 20 cart adds and zero orders in the 90 days to
      2026-08-25. A discount is worth nothing if it lands on top of the buy button.
    */
    var onQuotePage = !!document.getElementById('quote');
    var justSubmitted = /contact_posted/.test(window.location.search);
    var onCheckoutish =
      /\/(products|cart|checkouts?|challenge|account)/.test(path) || onQuotePage || justSubmitted;

    function open() {
      if (root.classList.contains('is-visible')) return;
      root.hidden = false;
      root.classList.add('is-visible');
      cleanup();
    }

    function close(rememberIt) {
      root.classList.remove('is-visible');
      root.hidden = true;
      if (rememberIt) remember(days);
      cleanup();
    }

    var timer = null;
    function onMouseOut(event) {
      if (event.clientY <= 0 && !event.relatedTarget) open();
    }
    function cleanup() {
      if (timer) { window.clearTimeout(timer); timer = null; }
      document.removeEventListener('mouseout', onMouseOut);
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-email-popup-close]')) {
        event.preventDefault();
        close(true);
      }
    });

    document.addEventListener('keydown', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && root.classList.contains('is-visible')) close(true);
    });

    if (form) {
      form.addEventListener('submit', function () {
        // The page reloads on submit; remember now so it does not reappear straight away.
        remember(days);
      });
    }

    // A successful signup renders the success message server-side: show it, then remember.
    if (posted) {
      open();
      remember(days);
      return;
    }

    if (suppressed() || onCheckoutish) return;

    timer = window.setTimeout(open, delay * 1000);
    document.addEventListener('mouseout', onMouseOut);
  }

  function initAll(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var list = Array.prototype.slice.call(scope.querySelectorAll('[data-email-popup]'));
    if (scope.matches && scope.matches('[data-email-popup]')) list.unshift(scope);
    list.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
